const schoolBussiness = {
    namespaced: true,
    state: {
        myCourses: [],
        menuOne: [],
        menuTwo: [],
        levelOne: null,
        levelTwo: null,
        courseCompleted: false,
        page: 1,
        loading: false,
        importantCourses: [],
        coursePrivate: [],
        courseFinish: [],
        //-----------------■コースセット対応--------------------------------------
        scheduleMenuOne: [],
        myScheduleCourses: [],
        scheduleLevelOne: null,
        scheduleLevelTwo: null,
        scheduleMenuTwo: [],
        scheduleCourseCompleted: false,
        schedulePage: 1,
        scheduleLoading: false,
        //-----------------■コースセット対応--------------------------------------
    },
    mutations: {
        setMyCourses(state, payload) {
            state.myCourses = payload;
        },
        setLevelOne(state, payload) {
            state.levelOne = payload;
        },
        setLevelTwo(state, payload) {
            state.levelTwo = payload;
        },
        setMenuOne(state, payload) {
            state.menuOne = payload;
        },
        setMenuTwo(state, payload) {
            state.menuTwo = payload;
        },
        setCourseCompleted(state, payload) {
            state.courseCompleted = payload;
        },
        setPage(state, payload) {
            state.page = payload;
        },
        setLoading(state, payload) {
            state.loading = payload;
        },
        setImportantCourses(state, payload) {
            state.importantCourses = payload;
        },
        setCoursePrivate(state, payload) {
            state.coursePrivate = payload;
        },
        setCourseFinish(state, payload) {
            state.courseFinish = payload;
        },
        //-----------------■コースセット対応--------------------------------------
        setScheduleMyCourses(state, payload) {
            state.myScheduleCourses = payload;
        },
        setScheduleLevelOne(state, payload) {
            state.scheduleLevelOne = payload;
        },
        setScheduleLevelTwo(state, payload) {
            state.scheduleLevelTwo = payload;
        },
        setScheduleMenuOne(state, payload) {
            state.scheduleMenuOne = payload;
        },
        setScheduleMenuTwo(state, payload) {
            state.scheduleMenuTwo = payload;
        },
        setScheduleCourseCompleted(state, payload) {
            state.scheduleCourseCompleted = payload;
        },
        setSchedulePage(state, payload) {
            state.schedulePage = payload;
        },
        setScheduleLoading(state, payload) {
            state.scheduleLoading = payload;
        },
        //-----------------■コースセット対応--------------------------------------
    },
    actions: {
        // Get course finish
        getCourseFinish: function ({ commit , dispatch}, data) {
            // Loading
            commit("setLoading", true);

            // get list all my course
            this._vm.$api
                .post("/collegecourse/getMyCourseFinishList", {
                    levelOne: null,
                    levelTwo: null,
                    pageNum: 1,
                    limit: 30,
                    lastPageFlag: 0,
                    languageType: data.language,
                    allFlag: 1,
                    type: 2,
                    flag: 0
                })
                .then((response) => {
                    if (response.data.length > 0) {
                        commit("setCourseFinish", response.data);
                    } else {
                        commit("setCourseFinish", []);
                    }
                });
        },
        // Danh sách khóa học được tạo bởi quyền cao nhất
        getImportantCourses: function ( {commit}, data) {
            this._vm.$api
                .post("/home/getImportantCourses", {
                    languageType: data.language,
                    checked: false,
                })
                .then((response) => {
                    // Biểu thức Regex check chuỗi bắt đầu http:// hoặc https://
                    let regex = new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/).*$/);
        
                    // check trường hợp có phải là khóa học live stream
                    let dataAfterCheckUrl = response.data.reduce((acc, curr) => {
                        curr['isUrl'] = false;
                        if (regex.test(curr.synopsis)) {
                            curr['isUrl'] = true;
                            let url = curr.synopsis.split("\r\n");
                            curr['courseCover'] = "<iframe width='100% !important' height='100% !important' src='" + url[1] + "' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"
                        }
                        acc.push(curr);
                        return acc;
                    }, []);
                    commit("setImportantCourses", dataAfterCheckUrl)
                });
        },
        convert: function ({ commit }, data) {
 
            // Biểu thức Regex check chuỗi bắt đầu http:// hoặc https://
            let regex = new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/).*$/);
 
            // check trường hợp có phải là khóa học live stream
            let dataAfterCheckUrl = data.reduce((acc, curr) => {
                curr['isUrl'] = false;
                if (regex.test(curr.synopsis)) {
                    curr['isUrl'] = true;
                    let url = curr.synopsis.split("\r\n");
                    curr['courseCover'] = "<iframe width='100% !important' height='100% !important' src='" + url[1] + "' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"
                }
                acc.push(curr);
                return acc;
            }, []);
 
            // let dataHot = dataAfterCheckUrl.filter(item => item.isHot == 1);
            // let dataNotHot = dataAfterCheckUrl.filter(item => item.isHot == 0);
            // dataHot = dataHot.sort(function (a, b) {
            //     return b.courseId - a.courseId;
            // });
            // let result = dataHot.concat(dataNotHot);
            
            // Sắp xếp khóa học mới nhất
            let result = dataAfterCheckUrl.sort(function (a, b) {
                return b.courseId - a.courseId;
            });
            
            //  Gán data vào store
            commit("setPage", 1);
            commit("setMyCourses", result);
            commit("setCoursePrivate", result);
            commit("setLoading", false);
        },
        convertCoursePrivate: function ({ commit }, data) {
 
            // Biểu thức Regex check chuỗi bắt đầu http:// hoặc https://
            let regex = new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/).*$/);
 
            // check trường hợp có phải là khóa học live stream
            let dataAfterCheckUrl = data.reduce((acc, curr) => {
                curr['isUrl'] = false;
                if (regex.test(curr.synopsis)) {
                    curr['isUrl'] = true;
                    let url = curr.synopsis.split("\r\n");
                    curr['courseCover'] = "<iframe width='100% !important' height='100% !important' src='" + url[1] + "' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"
                }
                acc.push(curr);
                return acc;
            }, []);
            
            // Sắp xếp khóa học mới nhất
            let result = dataAfterCheckUrl.sort(function (a, b) {
                return b.courseId - a.courseId;
            });
            
            //  Gán data vào store
            commit("setCoursePrivate", result);
            commit("setLoading", false);
        },
        resetDataCourse: function ({ commit }) {
            commit("setMyCourses", []);
            commit("setLevelOne", null);
            commit("setLevelTwo", null);
            commit("setMenuOne", []);
            commit("setMenuTwo", []);
            commit("setCourseCompleted", false);
            commit("setPage", 1);
        },
        getMenuLevelOne: function ({ commit }, data) {
            // Lấy về danh sách tag level 1
            this._vm.$api
                .post("/pullDownMenu/menuDataList", {
                    language: data.language,
                    level: 1,
                    tagOne: null,
                    tagTwo: null,
                    allFlag: 1,
                    type: 2,
                    flag: 0,
                    tagList: [],
                })
                .then((response) => {
                    let menuTagOneCApi = response.data;
                    menuTagOneCApi.unshift({ flag: false, id: null, language: data.language, name: data.name, number: 0 });
                    commit("setMenuOne", menuTagOneCApi);
                });
        },
        getMenuLevelTwo: function ({ commit }, data) {
            // Lấy về danh sách tag level 2
            this._vm.$api
                .post("/pullDownMenu/menuDataList", {
                    language: data.language,
                    tagOne: data.tagID,
                    level: 2,
                    tagList: [],
                })
                .then((response) => {
                    let menuTagTwoCApi = response.data;
                    menuTagTwoCApi.unshift({ flag: false, id: null, language: data.language, name: data.name, number: 0 });
                    commit("setMenuTwo", menuTagTwoCApi);
                });
        },
        getMyCourses: function ({ commit , dispatch}, data) {
            // Loading
            commit("setLoading", true);

            // Lấy về danh sách
            this._vm.$api
                .post("/collegecourse/getMyCourseList", {
                    levelOne: data.levelOne || null,
                    levelTwo: data.levelTwo || null,
                    pageNum: 1,
                    limit: 30,
                    lastPageFlag: 0,
                    languageType: data.language,
                    allFlag: 1,
                    type: 2,
                    flag: 0,
                    checked: data.courseCompleted || false,
                })
                .then((response) => {
                    if (data.isCoursePrivate) {
                        dispatch('convertCoursePrivate', response.data);
                    } else {
                        dispatch('convert', response.data);
                    }
                });
        },
        dislike: function ({ commit, state }, data) {
            this._vm.$api
                .post("/courseLike/delete", {
                    courseId: data.item.courseId,
                    commonId: data.item.commonId,
                })
                .then((response) => {
                    // TODO: Gán tạm vào mảng không cần phải gọi lại
                    let courses = state.myCourses;
                    let key = courses.findIndex(item => item.courseId == data.item.courseId);
                    // Khoa hoc noi bat
                    let importantCourses = state.importantCourses;
                    let keyimportantCourses = importantCourses.findIndex(item => item.courseId == data.item.courseId);
                    // Khoa hoc rieng
                    let scheduleMyCourses = state.myScheduleCourses;
                    let keyscheduleMyCourses = scheduleMyCourses.findIndex(item => item.courseId == data.item.courseId);
                    // course finish
                    let courseFinish = state.courseFinish;
                    let keyCourseFinish = courseFinish.findIndex(item => item.courseId == data.item.courseId);

                    if (key >= 0) {
                        courses[key].isLike = 0;
                        courses[key].likeNum = parseInt(courses[key].likeNum) - 1;
                    }

                    if (keyimportantCourses >= 0) {
                        importantCourses[keyimportantCourses].isLike = 0;
                        importantCourses[keyimportantCourses].likeNum = parseInt(importantCourses[keyimportantCourses].likeNum) - 1;
                    }

                    if (keyscheduleMyCourses >= 0) {
                        scheduleMyCourses[keyscheduleMyCourses].isLike = 0;
                        scheduleMyCourses[keyscheduleMyCourses].likeNum = parseInt(scheduleMyCourses[keyscheduleMyCourses].likeNum) - 1;
                    }

                    if (keyCourseFinish >= 0) {
                        courseFinish[keyCourseFinish].isLike = 0;
                        courseFinish[keyCourseFinish].likeNum = parseInt(courseFinish[keyCourseFinish].likeNum) - 1;
                    }

                    // Lưu lại danh sách khóa học
                    commit("setMyCourses", courses);

                    // Luu lai danh sach khoa hoc noi bat
                    commit("setImportantCourses", importantCourses);

                    // Luu lai danh sach khoa hoc rieng
                    commit("setScheduleMyCourses", scheduleMyCourses);

                    // save list course finish
                    commit("setCourseFinish", courseFinish);
                });
        },
        like: function ({ commit, state }, data) {
            this._vm.$api
                .post("/courseLike/save", {
                    courseId: data.item.courseId,
                    commonId: data.item.commonId,
                })
                .then((response) => {
                    // TODO: Gán tạm vào mảng không cần phải gọi lại
                    let courses = state.myCourses;
                    let key = courses.findIndex(item => item.courseId == data.item.courseId);
                    // khoa hoc noi bat
                    let importantCourses = state.importantCourses;
                    let keyimportantCourses = importantCourses.findIndex(item => item.courseId == data.item.courseId);
                    // Khoa hoc rieng
                    let scheduleMyCourses = state.myScheduleCourses;
                    let keyscheduleMyCourses = scheduleMyCourses.findIndex(item => item.courseId == data.item.courseId);
                    // course finish
                    let courseFinish = state.courseFinish;
                    let keyCourseFinish = courseFinish.findIndex(item => item.courseId == data.item.courseId);


                    if (key >= 0) {
                        courses[key].isLike = 1;
                        courses[key].likeNum = parseInt(courses[key].likeNum) + 1;
                    }

                    if (keyimportantCourses >= 0) {
                        importantCourses[keyimportantCourses].isLike = 1;
                        importantCourses[keyimportantCourses].likeNum = parseInt(importantCourses[keyimportantCourses].likeNum) + 1;
                    }

                    if (keyscheduleMyCourses >= 0) {
                        scheduleMyCourses[keyscheduleMyCourses].isLike = 1;
                        scheduleMyCourses[keyscheduleMyCourses].likeNum = parseInt(scheduleMyCourses[keyscheduleMyCourses].likeNum) + 1;
                    }

                    if (keyCourseFinish >= 0) {
                        courseFinish[keyCourseFinish].isLike = 1;
                        courseFinish[keyCourseFinish].likeNum = parseInt(courseFinish[keyCourseFinish].likeNum) + 1;
                    }

                    // Lưu lại danh sách khóa học
                    commit("setMyCourses", courses);

                    // Luu lai danh sach khoa hoc noi bat
                    commit("setImportantCourses", importantCourses);

                    // Luu lai danh sach khoa hoc rieng
                    commit("setScheduleMyCourses", scheduleMyCourses);

                    // save list course finish
                    commit("setCourseFinish", courseFinish);
                });
        },
        changeTagLvOne: function ({ commit, state, dispatch }, data) {
            // Gán tagID đúng level
            commit("setLevelOne", data.tagID);
            commit("setLevelTwo", null);

            //  Kiểm tra tagID
            let menuTagTwo = data.tagID == null ? [] : state.menuTwo;
            commit("setMenuTwo", menuTagTwo);

            // Lấy danh sách tag level 2
            if (data.tagID != null) {
                dispatch("getMenuLevelTwo", { tagID: data.tagID, name: data.name, language: data.language });
            }

            // Lưu lại danh sách khóa học
            dispatch("getMyCourses", { levelOne: state.levelOne, levelTwo: state.levelTwo, courseCompleted: state.courseCompleted, language: data.language, isCoursePrivate: data.isCoursePrivate });
        },
        changeTagLvTwo: function ({ commit, state, dispatch }, data) {
            // Gán tagID đúng level
            commit("setLevelTwo", data.tagID);

            // Lưu lại danh sách khóa học
            dispatch("getMyCourses", { levelOne: state.levelOne, levelTwo: state.levelTwo, courseCompleted: state.courseCompleted, language: data.language, isCoursePrivate: data.isCoursePrivate });
        },
        switchCourses: function ({ commit, state, dispatch }, data) {
            // Lưu trạng thái xem tất cả khóa học vào store
            commit("setCourseCompleted", data.courseCompleted);

            // Lưu lại danh sách khóa học
            dispatch("getMyCourses", { levelOne: state.levelOne, levelTwo: state.levelTwo, courseCompleted: state.courseCompleted, language: data.language });

            dispatch("switchScheduleCourses", data);
        },
        init: function ({ commit, state, dispatch }, data) {
            // Kiểm tra menu lv1 đã có dữ liệu chưa. Nếu chưa sẽ gọi lại từ đầu
            if (!state.menuOne.length) {
                // Gán null cho ID tag ở cả 2 lv
                commit("setLevelOne", data.tagID);
                commit("setLevelTwo", data.tagID);

                // Lấy và lưu danh sách tag level 1
                dispatch("getMenuLevelOne", { tagID: state.levelOne, name: data.name, language: data.language });

                // Lấy và lưu danh sách khóa học
                dispatch("getMyCourses", { levelOne: state.levelOne, levelTwo: state.levelTwo, courseCompleted: state.courseCompleted, language: data.language });

                // Lấy danh sách khóa học 
                dispatch("getImportantCourses", {language: data.language, courseCompleted: state.courseCompleted});

                dispatch("initSchedule", data);

                dispatch("getCourseFinish", { language: data.language })
            }
        },
        //-----------------■コースセット対応--------------------------------------
        scheduleConvert: function ({ commit }, data) {
 
            // Biểu thức Regex check chuỗi bắt đầu http:// hoặc https://
            let regex = new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/).*$/);
 
            // check trường hợp có phải là khóa học live stream
            let dataAfterCheckUrl = data.reduce((acc, curr) => {
                curr['isUrl'] = false;
                if (regex.test(curr.synopsis)) {
                    curr['isUrl'] = true;
                    let url = curr.synopsis.split("\r\n");
                    curr['courseCover'] = "<iframe width='100% !important' height='100% !important' src='" + url[1] + "' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"
                }
                acc.push(curr);
                return acc;
            }, []);
 
            let dataHot = dataAfterCheckUrl.filter(item => item.isHot == 1);
            let dataNotHot = dataAfterCheckUrl.filter(item => item.isHot == 0);
            dataHot = dataHot.sort(function (a, b) {
                return b.courseId - a.courseId;
            });
            let result = dataHot.concat(dataNotHot);
            
            //  Gán data vào store
            commit("setSchedulePage", 1);
            commit("setScheduleMyCourses", result);
            commit("setScheduleLoading", false);
        },
        scheduleResetDataCourse: function ({ commit }) {
            commit("setScheduleMyCourses", []);
            commit("setScheduleLevelOne", null);
            commit("setScheduleLevelTwo", null);
            commit("setScheduleMenuOne", []);
            commit("setScheduleMenuTwo", []);
            commit("setScheduleCourseCompleted", false);
            commit("setSchedulePage", 1);           
        },
        getScheduleMenuLevelOne: function ({ commit }, data) {
            // 检索标签列表 level 1
            this._vm.$api
                .post("/pullDownMenu/getScheduleMenuDataList", {
                    language: data.language,
                    level: 1,
                    tagOne: null,
                    tagTwo: null,
                    allFlag: 1,
                    type: 2,
                    flag: 0,
                    tagList: [],
                })
                .then((response) => {
                    let menuTagOneCApi = response.data;
                    menuTagOneCApi.unshift({ flag: false, id: null, language: data.language, name: data.name, number: 0 });
                    commit("setScheduleMenuOne", menuTagOneCApi);
                });
        },
        getScheduleMenuLevelTwo: function ({ commit }, data) {
            // 获取列表 tag level 2
            this._vm.$api
                .post("/pullDownMenu/getScheduleMenuDataList", {
                    language: data.language,
                    tagOne: data.tagID,
                    level: 2,
                    tagList: [],
                })
                .then((response) => {
                    let menuTagTwoCApi = response.data;
                    menuTagTwoCApi.unshift({ flag: false, id: null, language: data.language, name: data.name, number: 0 });
                    commit("setScheduleMenuTwo", menuTagTwoCApi);
                });
        },
        getScheduleMyCourses: function ({ commit , dispatch}, data) {
            // Loading
            commit("setScheduleLoading", true);

            // Lấy về danh sách
            this._vm.$api
                .post("/collegecourse/getScheduleMyCourseList", {
                    levelOne: data.levelOne || null,
                    levelTwo: data.levelTwo || null,
                    pageNum: 1,
                    limit: 30,
                    lastPageFlag: 0,
                    languageType: data.language,
                    allFlag: 1,
                    type: 2,
                    flag: 0,
                    checked: data.courseCompleted || false,
                })
                .then((response) => {
                    dispatch('scheduleConvert', response.data)
                });
        },
        scheduleChangeTagLvOne: function ({ commit, state, dispatch }, data) {
            // Gán tagID đúng level
            commit("setScheduleLevelOne", data.tagID);
            commit("setScheduleLevelTwo", null);

            //  Kiểm tra tagID
            let menuTagTwo = data.tagID == null ? [] : state.scheduleMenuTwo;
            commit("setScheduleMenuTwo", menuTagTwo);

            // Lấy danh sách tag level 2
            if (data.tagID != null) {
                dispatch("getScheduleMenuLevelTwo", { tagID: data.tagID, name: data.name, language: data.language });
            }

            // Lưu lại danh sách khóa học
            dispatch("getScheduleMyCourses", { levelOne: state.scheduleLevelOne, levelTwo: state.scheduleLevelTwo, courseCompleted: state.scheduleCourseCompleted, language: data.language });
        },
        scheduleChangeTagLvTwo: function ({ commit, state, dispatch }, data) {
            // Gán tagID đúng level
            commit("setScheduleLevelTwo", data.tagID);

            // Lưu lại danh sách khóa học
            dispatch("getScheduleMyCourses", { levelOne: state.scheduleLevelOne, levelTwo: state.scheduleLevelTwo, scheduleCourseCompleted: state.courseCompleted, language: data.language });
        },
        switchScheduleCourses: function ({ commit, state, dispatch }, data) {
            // 将查看所有课程的状态保存到商店
            commit("setScheduleCourseCompleted", data.courseCompleted);

            // 保存课程列表
            dispatch("getScheduleMyCourses", { levelOne: state.scheduleLevelOne, levelTwo: state.scheduleLevelTwo, courseCompleted: state.scheduleCourseCompleted, language: data.language });
        },
        initSchedule: function ({ commit, state, dispatch }, data) {
            //检查lvl1菜单是否有数据。 如果没有，我会从头回电话
            if (!state.scheduleMenuOne.length) {
                // 在两个级别为 ID 标签设置 null
                commit("setScheduleLevelOne", data.tagID);
                commit("setScheduleLevelTwo", data.tagID);

                // 获取并保存 1 级标签列表
                dispatch("getScheduleMenuLevelOne", { tagID: state.scheduleLevelOne, name: data.name, language: data.language });

                // 获取并保存课程列表
                dispatch("getScheduleMyCourses", { levelOne: state.scheduleLevelOne, levelTwo: state.levelTwo, courseCompleted: state.scheduleCourseCompleted, language: data.language });
            }
        },
        //-----------------■コースセット対応--------------------------------------
    },
    getters: {
        myCourses(state) {
            return state.myCourses;
        },
        levelOne(state) {
            return state.levelOne;
        },
        levelTwo(state) {
            return state.levelTwo;
        },
        menuOne(state) {
            return state.menuOne;
        },
        menuTwo(state) {
            return state.menuTwo;
        },
        courseCompleted(state) {
            return state.courseCompleted;
        },
        importantCourses(state) {
            return state.importantCourses;
        },
        coursePrivate(state) {
            return state.coursePrivate;
        },
        courseFinish(state) {
            return state.courseFinish;
        },
        //-----------------■コースセット対応--------------------------------------
        scheduleLevelOne(state) {
            return state.scheduleLevelOne;
        },
        scheduleLevelTwo(state) {
            return state.scheduleLevelTwo;
        },
        scheduleMenuOne(state) {
            return state.scheduleMenuOne;
        },
        scheduleMenuTwo(state) {
            return state.scheduleMenuTwo;
        },
        scheduleCourseCompleted(state) {
            return state.scheduleCourseCompleted;
        },
        //-----------------■コースセット対応--------------------------------------
    },
};

export default schoolBussiness;



// WEBPACK FOOTER //
// ./src/stores/modules/schoolBussiness.js